import { render } from "./templateHeaderMaslenica.vue?vue&type=template&id=2eef5435&scoped=true"
import script from "./templateHeaderMaslenica.vue?vue&type=script&lang=js"
export * from "./templateHeaderMaslenica.vue?vue&type=script&lang=js"

import "./templateHeaderMaslenica.vue?vue&type=style&index=0&id=2eef5435&scoped=true&lang=css"

import exportComponent from "/Users/konstantinkorobitsin/Work/ar-game-constructor/ar-game-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eef5435"]])

export default __exports__